module.exports = {"confirm":"OK","cancel":"Cancel","save":"Save","delete":"Delete","edit":"Edit","register":"Register","search":"Search","close":"Close","all":"All","select":"Select","list":"List","download":"Download","hole":"Hole","course":"Course","golfClub":"Golf Club","weekdays":["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],"everyWeek":"Every {day}","everyMonth":"{week} {day} of every month"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/en/common.json
// module id = /uRe
// module chunks = 2